<template>
  <ul
    class="pb-3 mt-4 pb-md-0 unstyled-list"
    :class="{ [$style.container]: true, [$style.containerMini]: miniBasket }"
  >
    <BasketProductSplitItem
      v-show="amountAsap"
      :class="$style.item"
      :mini-basket="miniBasket"
      :is-mobile="isMobile"
      :type="$t('checkout.basket.variant.asap')"
      :product-id="productId"
      :delivery-terms="deliveryTerms"
      :self-url="selfUrl"
      :amount="amountAsap"
      :basket-status="basketStatus"
      :basket-status-is-ok="basketStatusIsOk"
      :payment-terms="paymentTerms"
      :custom-basket-attributes="customBasketAttributes"
      class="mb-6"
      :pending="pending"
      @updateBasketItem="$emit('updateBasketItem', $event)"
    />
    <BasketProductSplitItem
      v-for="item in productOrderDate"
      :key="item.key"
      :split-key="item.key"
      :class="$style.item"
      :mini-basket="miniBasket"
      :is-mobile="isMobile"
      :delivery-terms="item.deliveryTerms"
      :type="$t('checkout.basket.variant.date', { date: item.dateFormatted })"
      :self-url="item.selfUrl"
      :amount="item.quantity"
      :basket-status="item.basketStatus"
      :basket-status-is-ok="item.basketStatusIsOk"
      :payment-terms="item.paymentTerms"
      :custom-basket-attributes="item.customBasketAttributes"
      split-type="productOrderDate"
      class="mb-6"
      :pending="pending"
      @updateBasketItem="$emit('updateBasketItem', $event)"
    />
    <BasketProductSplitItem
      v-for="item in productOrderCw"
      :key="item.key"
      :split-key="item.key"
      :class="$style.item"
      :mini-basket="miniBasket"
      :is-mobile="isMobile"
      :delivery-terms="item.deliveryTerms"
      :type="
        $t('checkout.basket.variant.cw', {
          date: item.dateFormatted,
          week: item.week,
          year: item.year,
        })
      "
      :self-url="item.selfUrl"
      :amount="item.quantity"
      :basket-status="item.basketStatus"
      :basket-status-is-ok="item.basketStatusIsOk"
      :payment-terms="item.paymentTerms"
      :custom-basket-attributes="item.customBasketAttributes"
      split-type="productOrderCw"
      class="mb-6"
      :pending="pending"
      @updateBasketItem="$emit('updateBasketItem', $event)"
    />
  </ul>
</template>

<script>
import { DELIVERY_TERMS } from '@/js/helper/delivery-constants.js'
// import BasketDeliverySwitch from '@/js/components/Basket/BasketDeliverySwitch.vue'
import BasketProductSplitItem from '@/js/components/Basket/BasketProductSplitItem.vue'

export default {
  name: 'BasketProductSplit',
  components: { BasketProductSplitItem },
  props: {
    miniBasket: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: String,
      default: '',
    },
    amountAsap: {
      type: Number,
      default: 0,
    },
    // variants: {
    //   type: Object,
    //   default: () => ({}),
    // },
    productOrderDate: {
      type: Array,
      default: () => [],
    },
    productOrderCw: {
      type: Array,
      default: () => [],
    },
    selfUrl: {
      type: String,
      default: undefined,
    },
    paymentTerms: {
      type: Array,
      default: () => [],
    },
    deliveryTerms: {
      type: Array,
      default: () => [],
    },
    customBasketAttributes: {
      type: Object,
      default: () => ({}),
    },
    basketStatus: {
      type: String,
      default: undefined,
    },
    basketStatusIsOk: {
      type: Boolean,
      default: false,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deliveryStates: DELIVERY_TERMS,
    }
  },
  methods: {
    // updateProduct(type, e, selfUrl, quantity, customBasketAttributes) {
    //   this.$emit('updateBasketItem', {
    //     productId: this.productId,
    //     type,
    //     value: e,
    //     selfUrl,
    //     quantity,
    //     customBasketAttributes,
    //   })
    // },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-wrap: wrap;
  min-width: 100%;
}

.item {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    grid-row-gap: 0.35rem;
    grid-column-gap: 0.5rem;

    grid-template-areas:
      'type type delivery payment quantity . . . .'
      'message message message message message message message message message';
    grid-template-columns: 6rem minmax(6rem, 50%) minmax(6rem, 12rem) minmax(6rem, 50%) 4.5rem 3rem 8rem 8rem 3rem;
    margin-bottom: 1.5rem !important;
    padding: 0;

    background: none;
  }
  display: grid;
  grid-row-gap: 1rem;
  grid-column-gap: 0.2rem;

  grid-template-areas:
    'type type type paymentCheckout paymentCheckout .'
    'type type type payment payment .'
    'quantityLabel quantity . delivery delivery delivery'
    'message message message message message message';

  grid-template-rows: auto;
  grid-template-columns: 5.5rem minmax(1rem, 1fr) 1fr 3fr 3fr 1fr;

  align-items: center;
  width: 100%;
  margin-bottom: 1.5rem !important;
  padding: 0.5rem 0 0.5rem 0.5rem !important;

  background: #e7f1f5;
  border-radius: 5px;

  &:last-child {
    margin-bottom: 0 !important;
  }
}

.containerMini .item {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    grid-template-areas:
      'type payment quantity delivery delivery delivery'
      'message message message message message message';
    grid-template-rows: auto;
    grid-template-columns: minmax(10rem, 1fr) minmax(6rem, 2fr) 2.5rem 2rem 8rem 2rem;
    padding: 0;

    background: none;
  }

  grid-template-areas:
    'type type type payment payment .'
    'quantityLabel quantity . delivery delivery .'
    'message message message message message message';
  grid-template-rows: auto;
  grid-template-columns: 5.5rem minmax(1rem, 1fr) 1fr 3fr 3fr 1fr;

  padding: 0.5rem 0 0.5rem 0.5rem !important;

  background: #e7f1f5;
  border-radius: 5px;
}

.type {
  grid-area: type;
}

.paymentTerms {
  grid-area: payment;
}

.deliveryType {
  grid-area: delivery;
}

.basketmessage {
  grid-area: message;

  color: var(--error);
  font-size: 0.75rem;
  line-height: 0.875rem;
}

.select {
  padding-top: 0.5rem;
}

.type,
.amount,
.select,
.switch :global(.v-label) {
  font-weight: normal;
  font-size: 0.875rem;
}

.amount {
  grid-area: quantity;

  text-align: right;
}

// .amount,
// .paymentTerms,
// .deliveryType {
//   margin-left: 0.5rem;
// }
</style>
